import { EEVENT_LABEL } from 'affiny-core/analytics';
import { ReactElement } from 'react';
import { BoxProps } from '../primitives/box';
import { TextProps } from '../primitives/text';

/* ***** *****  Global types  ***** ***** */

export enum BREAKER_TYPE {
  FAVORITE = 'FAVORITE',
  FTI_SENT = 'FTI_SENT',
  FTA_RECEIVED = 'FTA_RECEIVED',
  FTA = 'FTA',
  PHOTO = 'PHOTO',
  BLOCKED = 'BLOCKED',
  LIST = 'LIST',
}

export interface Props {
  title: string;
  subtitle?: string | ReactElement;
  textBtn?: string;
  specialOfferText?: string;
  onClick?: () => void;
  type: BREAKER_TYPE;
  illustration?: ReactElement;
  wrapperStyle?: Omit<BoxProps, 'color'>;
  titleStyle?: Omit<TextProps, 'color'>;
  subTitleStyle?: Omit<TextProps, 'color'>;
  boxStyle?: Omit<BoxProps, 'color'>;
  trackEvent?: EEVENT_LABEL;
}
